import { useState } from 'react';

const useFetchData = (apiFunction) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const fetchData = async () => {
        try {
            setIsLoading(true);
            setErrorMessage('');
            const response = await apiFunction();
            if (response) {
                setData(response);
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setErrorMessage('Failed to fetch data');
        } finally {
            setIsLoading(false);
        }
    };

    return { data, isLoading, errorMessage, fetchData };
};

export default useFetchData;